import type { FaireProductEntity } from "../../entity_types/product";

export const p_kk6czfm2bc: FaireProductEntity = {
  token: "p_kk6czfm2bc",
  type: "product",
  name: "Bunny Berry Village KidDough Play Kit",
  brandToken: "b_ehvufz5nw9",
  brandName: "Earth Grown KidDoughs (KidDoughs by EGKD)",
  imageUrl:
    "https://cdn.faire.com/fastly/275ce29fb14a47eb121410324e9a8da9013dfc1343b30310600f15f62d727ae3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dcc74e5528b40f064e290ab5f3eff441b6b95b9b8a4816ac207b89967cd5fa74.jpeg",
    "https://cdn.faire.com/fastly/8ff43e58c601110cdc7f6627f2a37c383658281db7e7ef72651ba25d484e81f0.jpeg",
    "https://cdn.faire.com/fastly/82a2ea530f83a0511a60e670bc42df63162f80e08be7c940657debb409a6c449.jpeg",
    "https://cdn.faire.com/fastly/7f6200a2701620c21049370f5e6e1449321c349282e9ec48dab8974a7bebd238.jpeg",
    "https://cdn.faire.com/fastly/1ad0e98bfe17cfd64513f052eb466309dc1e4c0359007ec01f1c632c153258e4.jpeg",
  ],
  priceDollars: 12.5,
  description:
    "This enchanting play kit invites little creators to mold and shape their own garden village, complete with adorable bunny friends, whimsical mushrooms, and lush greenery. Craft a magical world of vibrant flowers, cozy bunny burrows, and tiny toadstool houses. Perfect for sparking imagination, fine motor skills, and storytelling fun!\n\nIncludes: 8 oz Green (Strawberry Shortcake) KidDough with Bunny Village character charms, mushroom house, strawberry house, strawberry snail, bunnies, foliage and ferns, strawberry sprinkles, strawberries, and berry baskets.\n\nAbout our products:\nOur super silky sensory doughs are buildable like a modeling compound; however, they are softer, more pliable, and far longer lasting than any you have tried before! Every all-natural KidDough is made with non-toxic food-grade ingredients and is totally taste-safe. These super durable doughs last for at least 120 hours of active air time and easily wash out of carpets and fabric with just warm water. If ever you experience drying, just knead to rehydrate. KidDough is the best way to play dough!\n\nHandmade in the USA\n\nThis Play Kit is recommended for Ages 3+\n\nScent: Strawberry Shortcake\n\nIngredients: Wheat Flour, Salt, Canola Oil, Cream of Tartar, Water, Food Coloring, Organic Potassium Sorbate, and Natural Fragrance\n",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:46.889Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
